/* src/app/order/confirmation/confirmation.component.css */
.float-left {
  float: left;
}
/*# sourceMappingURL=confirmation.component.css.map */
